import { createAsyncThunk } from '@reduxjs/toolkit';
import { checkHighestVersionStrategy } from '../services/applePay/getHighestSupportedVersion';

export const checkApHighestSupportedVersion = createAsyncThunk<number, null, { rejectValue: null }>(
  'HIGHEST_SUPPORTED_APPLE_PAY_VERSION',
  () => {
    return checkHighestVersionStrategy();
  },
);
